import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './queries';

export const alliesApi = createApi({
  reducerPath: 'alliesApi',
  baseQuery,
  tagTypes: ['network-admins'],
  endpoints: (builder) => ({
    resendAllyInvite: builder.mutation({
      query: ({ adminId, networkId: collectionId }) => ({
        url: `/users/${adminId}/invitation_email/ally`,
        method: 'POST',
        data: {
          collectionId,
        },
      }),
    }),
  }),
});

export const { useResendAllyInviteMutation } = alliesApi;
